'use strict';

module.exports = {
  name:     'resize',
  fn:       require('./resize'),
  wasm_fn:  require('./resize_wasm'),
  wasm_src: require('./convolve_wasm_base64')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/pica/lib/mm_resize/index.js
// module id = 99
// module chunks = 0 2 3